/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WonItem = {
    /**
     * Won item ID
     */
    id?: string;
    /**
     * Original item ID
     */
    itemId?: string;
    /**
     * Item name
     */
    name?: string;
    /**
     * Item image URL
     */
    image?: string;
    /**
     * Item price in cents
     */
    price?: number;
    /**
     * Item rarity
     */
    rarity?: string;
    /**
     * Item type
     */
    type?: string;
    /**
     * Weapon type
     */
    weapon?: string;
    /**
     * Skin name
     */
    skin?: string;
    /**
     * Item exterior condition
     */
    exterior?: string;
    /**
     * Item color
     */
    color?: string;
    /**
     * Whether item is unstable
     */
    unstable?: boolean;
    /**
     * Whether item has StatTrak
     */
    stattrak?: boolean;
    /**
     * Item status: 0=Available, 1=Pending, 2=Sold, 3=Withdrawn, 4=Locked
     */
    status?: WonItem.status;
    /**
     * Owner user ID
     */
    userId?: string;
    /**
     * Incoming transaction ID
     */
    incomingTxId?: string;
    /**
     * Whether this opening awarded a case token
     */
    caseTokenAwarded?: boolean;
};
export namespace WonItem {
    /**
     * Item status: 0=Available, 1=Pending, 2=Sold, 3=Withdrawn, 4=Locked
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
    }
}

